import React, {
    useCallback,
    useContext,
    useMemo,
    useState
} from 'react';
import _ from 'lodash';
import { TranslatorContext } from '@jutro/locale';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { wizardProps } from 'wmic-pe-portals-custom-wizard-react';
import { useValidation } from '@xengage/gw-portals-validation-react'
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { WMICWizardChangeOrRenewalPage, useWizardModals, useDocumentTitle } from 'wmic-pe-portals-wizard-components-ui';
import { WMICUserAccessUtil } from 'wmic-pe-portals-utils-js';
import { WMICPolicyDetailsComponent } from 'wmic-pe-capability-gateway-common-react';

import { messages as commonMessages } from 'wmic-pe-capability-gateway-policychange-common-react';

function WMICPUPPolicyChangePolicyDetailsPage(props) {
    const {
        wizardData: policyChangeVM,
        updateWizardData
    } = props;

    const { EndorsementService } = useDependencies('EndorsementService');
    const { setWizardLoading } = useWizardModals();
    const translator = useContext(TranslatorContext);
    const { authHeader, authUserData } = useAuthentication();
    const [showErrors, setShowErrors] = useState(false);

    const {
        onValidate: setComponentValidation,
        isComponentValid
    } = useValidation('WMICPUPPolicyChangePolicyDetailsPage');

    useDocumentTitle(translator(commonMessages.policyDetailsTitle), policyChangeVM);

    const canEditPolicyChange = useMemo(() => WMICUserAccessUtil.canEditPolicyChange(authUserData.permission_Ext), [authUserData.permission_Ext]);

    const onNext = useCallback(async () => {

        if(!isComponentValid)  {
            setShowErrors(true);
            return false;
        }

        try {
            setWizardLoading(true);

            const newPolicyChangeVM = _.cloneDeep(policyChangeVM.value);

            policyChangeVM.value = await EndorsementService.saveEndorsement(
                [newPolicyChangeVM],
                authHeader
            );
            updateWizardData(policyChangeVM);

            return policyChangeVM;
        } finally {
            setWizardLoading(false);
        }
    }, [isComponentValid, setWizardLoading, policyChangeVM, EndorsementService, authHeader, updateWizardData]);

    return (
        <WMICWizardChangeOrRenewalPage
            onNext={onNext}
            cancelLabel={translator(commonMessages.saveAndExit)}
            showRequired
        >
            <WMICPolicyDetailsComponent
                jobVM={policyChangeVM}
                updateWizardData={updateWizardData}
                onValidate={setComponentValidation}
                isReadOnly={!canEditPolicyChange}
                authHeader={authHeader}
                showErrors={showErrors}
            />
        </WMICWizardChangeOrRenewalPage>
    );
}

WMICPUPPolicyChangePolicyDetailsPage.propTypes = wizardProps;

export default withViewModelService(WMICPUPPolicyChangePolicyDetailsPage);
